import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import ConfigStore from '../../stores/ConfigStore';
import AppStatusStore from '../../stores/AppStatusStore';
import AppDispatcher from '../../utils/AppDispatcher';
import { actions as StatusActions, events as StatusEvents } from '../../constants/StatusConstants';
import StatusComponent from './StatusComponent.react';
import Incident from './Incident.react';
import PageHeader from '../form/layout/PageHeader.react';

class StatusPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            currentStatus: null,
            error: null,
        };
        this.refresh = this.refresh.bind(this);
        this.checkBiotrack = this.checkBiotrack.bind(this);
        this.checkMetrc = this.checkMetrc.bind(this);
        this.customerHasComponent = this.customerHasComponent.bind(this);
        this.onStatusStoreNewStatus = this.onStatusStoreNewStatus.bind(this);
    }

    componentDidMount() {
        this.refresh();
        AppStatusStore.addChangeListener(StatusEvents.STATUS_RELOADED, this.onStatusStoreNewStatus);
    }

    componentWillUnmount() {
        AppStatusStore.removeChangeListener(StatusEvents.STATUS_RELOADED, this.onStatusStoreNewStatus);
    }

    onStatusStoreNewStatus() {
        this.setState({ currentStatus: AppStatusStore.statusSummary, loading: false });
    }

   

    refresh() {
        this.setState({ loading: true });
        setTimeout(() => {
            AppDispatcher.dispatch({
                actionType: StatusActions.RELOAD_STATUS
            });
        }, 100);
    }
    
    checkMetrc(componentName) {
        return this.props.selectedLocation.UseMETRC && 
        !!this.props.selectedLocation.IntegratedState &&
        componentName.slice(8).toLowerCase() === this.props.selectedLocation.IntegratedState.toLowerCase();
    }

    checkBiotrack(componentName) {
        return this.props.selectedLocation.UseBioTrack && 
        !!this.props.selectedLocation.IntegratedState &&
        componentName.slice(11).toLowerCase() === this.props.selectedLocation.IntegratedState.toLowerCase();
    }

    checkRegion(componentName) {
        return componentName.indexOf(ConfigStore.getRegion()) > -1;
    }

    customerHasComponent(componentName) {
        var toCheck = componentName.toLowerCase();
        if(toCheck.indexOf('metrc') > -1) {
            return this.checkMetrc(toCheck);
        } else if(toCheck.indexOf('biotrack') > -1) {
            return this.checkBiotrack(toCheck);
        } else if(toCheck.indexOf('backend') >-1 || toCheck.indexOf('pos') > -1) {
            return this.checkRegion(toCheck);
        } else if(toCheck === 'leaf') {
            return this.props.selectedLocation.UseLeaf;
        } else if(toCheck === 'mn omc') {
            return this.props.selectedLocation.UseMN;
        }else {
            return true;
        }
    }


    render() {
        let content = null;
        if (this.state.loading) {
            content = <i className='fa fa-spinner fa-pulse' /> ;
        } else if (this.state.error) {
            content = <div> { this.state.error } </div>;
        } else if (!!this.state.currentStatus && this.state.currentStatus.components && this.state.currentStatus.components.length > 0) {
            let customerComponents = this.state.currentStatus.components
            .filter(x => (x.group_id != null || !x.group) && this.customerHasComponent(x.name) );
            content = <div>
            <div> 
                { 
                    customerComponents.map((x, i) => <StatusComponent component={x} />)
                }
               
             </div>
             
            { this.state.currentStatus.incidents.length > 0 && 
                <div>
                    <PageHeader title='Ongoing Incidents' />
                    {
                        this.state.currentStatus.incidents
                        .filter(x => {
                            return _.findIndex(customerComponents, (component : any) => x.name.indexOf(component.name) > -1) > -1;
                        } )
                        .sort((a, b) => moment(a.created_at).isAfter(moment(b.created_at)) ? 1 : -1 )
                        .map((x, i) => <Incident incident={x}/>)
                    }
                </div>
            }

         
             </div>;
        }

        return content;
        
    }


}

export default StatusPage;


// WEBPACK FOOTER //
// ./ui_src/app/components/status/StatusPage.react.jsx